import React, {useEffect} from 'react';
import {ReactComponent as CloseIcon} from '../../../../../assets/icons/closeLarge.svg';
import {useTranslation} from 'react-i18next';
import './ChatParticipants.scss';
import NoItems from '../../../NoItems';
import AvatarSpectator from '../../../../../assets/images/avatars/avatar-spectator.png';
import AvatarUser from '../../../../../assets/images/avatars/avatar-users.png';
import {NavLink} from 'react-router-dom';
import {mainPath} from '../../../../../routes/paths';
import {useSelector} from 'react-redux';

const ChatParticipants = ({title, descriptions, handleCloseUsers, activeChatType, projectMembersList}) => {
  const {t} = useTranslation();
  const profileMe = useSelector((state) => state.profile.profileMe);
  const {singleProject} = useSelector((state) => state.projects);
  const isSpectatorOrClient = profileMe?.role === 'user' || profileMe?.role === 'spectator';

  useEffect(() => {}, [activeChatType]);

  return (
    <div className='chat-participants'>
      <div className='chat-participants__head'>
        <div>
          <div className='chat-participants__descriptions'>
            {`${
              activeChatType === 'default'
                ? projectMembersList?.clients?.length + projectMembersList?.employees?.length || 0
                : projectMembersList?.employees?.length || 0
            } ${descriptions}`}
          </div>
          <div className='chat-participants__title'>{title}</div>
        </div>
        <div className='chat-participants__close' onClick={handleCloseUsers}>
          <CloseIcon />
        </div>
      </div>

      {projectMembersList?.clients?.length >= 1 || projectMembersList?.employees?.length >= 1 ? (
        <div className='chat-participants__list-wrapper'>
          <ul className='chat-participants__list'>
            {projectMembersList.employees &&
              Array.isArray(projectMembersList.employees) &&
              projectMembersList.employees.map(({firstName, avatar, positionName, id, employeeId}) => (
                <NavLink
                  to={mainPath.projectsParticipantsEmployee
                    .replace(':id', singleProject?.id)
                    .replace(':userId', employeeId)}
                  key={id}
                  onClick={(e)=>{
                    if(isSpectatorOrClient) {
                      e.preventDefault();
                    }
                  }}
                  className='chat-participants__item'
                >
                  <div className='chat-participants__avatar'>
                    {avatar ? (
                      <img className='avatar-image' src={avatar} alt={firstName} />
                    ) : (
                      <img className='avatar-image' src={AvatarUser} alt={firstName} />
                    )}
                  </div>
                  <div className='chat-participants__info'>
                    <span className='chat-participants__name'>{firstName}</span>
                    <span className='chat-participants__role'>{positionName}</span>
                  </div>
                </NavLink>
              ))}

            {activeChatType === 'default' &&
              projectMembersList.clients &&
              Array.isArray(projectMembersList.clients) &&
              projectMembersList.clients.map(({firstName, roleName, role, avatar, id, clientId}) => (
                <NavLink
                  to={mainPath.projectsParticipantsClient
                    .replace(':id', singleProject?.id)
                    .replace(':clientId', clientId)}
                  key={id}
                  onClick={(e)=>{
                    if(isSpectatorOrClient) {
                      e.preventDefault();
                    }
                  }}
                  className='chat-participants__item'
                >
                  <div className='chat-participants__avatar'>
                    {avatar ? (
                      <img className='avatar-image' src={avatar} alt={firstName} />
                    ) : role === 'spectator' ? (
                      <img className='avatar-image' src={AvatarSpectator} alt={firstName} />
                    ) : (
                      <img className='avatar-image' src={AvatarUser} alt={firstName} />
                    )}
                  </div>
                  <div className='chat-participants__info'>
                    <span className='chat-participants__name'>{firstName}</span>
                    <span className='chat-participants__role'>{roleName}</span>
                  </div>
                </NavLink>
              ))}
          </ul>
        </div>
      ) : (
        <NoItems
          description={t('ChatParticipants.addParticipant')}
          title={t('ChatParticipants.noParticipants')}
          center={'center'}
        />
      )}
    </div>
  );
};

export default ChatParticipants;
